import { render, staticRenderFns } from "./IconWhatsapp.vue?vue&type=template&id=e9045082&scoped=true&"
import script from "./IconWhatsapp.vue?vue&type=script&lang=js&"
export * from "./IconWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9045082",
  null
  
)

export default component.exports